<template>
  <div class="vote_login_box" v-loading="voteLoginLoading">
    <div v-if="!isShowLoginForm" class="meeting_title">
      欢迎使用企业云投票系统
    </div>
    <div
      v-if="
        isShowLoginForm &&
        !meetingState.IsLogin &&
        meetingState.NoLoginType !== 2
      "
    >
      <span v-if="meetingState.NoLoginType === 1">会议未开始</span>
      <span v-if="meetingState.NoLoginType === 3">会议不存在</span>
    </div>
    <div
      v-if="
        isShowLoginForm &&
        !meetingState.IsLogin &&
        meetingState.NoLoginType === 2
      "
    >
      <span v-if="meetingState.NoLoginType === 2">
        匿名会议，请使用微信小程序投票
      </span>
      <!-- <el-button
        type="primary"
        class="login_submit_btn"
        v-on:click="anonymousLogin()"
        v-loading.fullscreen.lock="loginLoading"
        element-loading-text="正在登录…"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        开始投票
      </el-button> -->
    </div>
    <div
      v-if="isShowLoginForm && meetingState.IsLogin"
      class="meeting_title"
      v-html="meetingState.HtmlMeetingName"
    ></div>
    <el-row
      v-if="isShowLoginForm && meetingState.IsLogin"
      class="vote_login_row"
    >
      <el-col
        :xs="{ span: 18, offset: 3 }"
        :sm="{ span: 8, offset: 8 }"
        :md="{ span: 8, offset: 8 }"
        :lg="{ span: 6, offset: 9 }"
        :xl="{ span: 4, offset: 10 }"
      >
        <div class="login_divider">
          <span> 登录会议开始投票 </span>
        </div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="0px"
          class="login_box_form"
        >
          <el-form-item label="" prop="username">
            <el-input
              type="text"
              v-model="ruleForm.username"
              placeholder="请输入用户名"
              prefix-icon="el-icon-user-solid"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="" prop="password">
            <el-input
              type="text"
              v-model="ruleForm.password"
              placeholder="请输入密码"
              prefix-icon="el-icon-lock"
              clearable
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              class="login_submit_btn"
              v-on:click="submitForm('ruleForm')"
              v-loading.fullscreen.lock="loginLoading"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(0, 0, 0, 0.8)"
            >
              登录
            </el-button>
          </el-form-item>
          <el-form-item
            v-if="meetingState.IsVoteUserApply || meetingState.IsAllowWatch"
          >
            <div class="user_apply_btn_box">
              <el-link
                type="primary"
                @click="openVoteUserApply()"
                v-if="meetingState.IsVoteUserApply"
              >
                <i class="iconfont icon-baoming"></i>
                我要{{ meetingState.ApplyButtonText }}
              </el-link>
              <el-link
                type="primary"
                @click="watchLogin()"
                v-if="meetingState.IsAllowWatch"
              >
                <i class="iconfont icon-toupiaoguanli"></i>
                参观会议投票
              </el-link>
            </div>
          </el-form-item>
          <el-form-item v-if="meetingState.TipsContent">
            <H4> {{ meetingState.TipsTitle }}</H4>
            <div v-html="meetingState.TipsContent"></div>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row class="vote_login_row" v-if="false">
      <el-col
        :xs="{ span: 18, offset: 3 }"
        :sm="{ span: 8, offset: 8 }"
        :md="{ span: 8, offset: 8 }"
        :lg="{ span: 6, offset: 9 }"
        :xl="{ span: 4, offset: 10 }"
      >
        <div class="vote_login_scan">
          <div class="login_divider">
            <span> 您还可以 </span>
          </div>
          <a>
            <i class="iconfont icon-saoma1"></i>
          </a>
          <span>扫码投票</span>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import voteApi from '../../api/mobileVote/vote'
export default {
  data () {
    return {
      isShowLoginForm: false,
      voteLoginLoading: true,
      loginLoading: false,
      meetingState: {
        IsLogin: false,
        NoLoginType: 0,
        MeetingName: '',
        IsVoteUserApply: false,
        IsGoApply: false
      },
      ruleForm: {
        username: '',
        password: '',
        isRemember: false
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 1, max: 13, message: '长度在 1 到 13 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    getVoteList: function () {
      const _this = this
      voteApi.getMeetingState({
        meetingID: _this.$route.params.mid
      })
        .then(data => {
          _this.meetingState = data
          if (_this.meetingState.NoLoginType === 2) {
            // _this.anonymousLogin()
          }
          if (_this.meetingState.IsVoteUserApply) {
            if (_this.meetingState.IsGoApply) {
              _this.$router.push({ name: 'voteUserApply', params: { mid: _this.$route.params.mid, cid: _this.$route.params.cid } })
            }
          }
          _this.voteLoginLoading = false
        }).catch(err => {
          return err
        })
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loginLoading = true
          var params = new URLSearchParams()
          params.append('grant_type', 'password')
          params.append('login_mode', 'voters')
          params.append('username', this.ruleForm.username)
          params.append('password', this.ruleForm.password)
          params.append('meeting_id', this.$route.params.mid)
          params.append('company_id', this.$route.params.cid)
          this.$api.account.login(params)
            .then(data => {
              const saveParam = {
                token: data.access_token,
                token_type: data.token_type,
                refresh_token: data.refresh_token,
                expires_in: data.expires_in,
                issued: data['.issued'],
                expires: data['.expires'],
                role: 'voter',
                rememberClient: this.ruleForm.isRemember
              }
              this.$store.commit('ADD_ACCOUNT', saveParam)
              this.$router.push({ name: 'voteList', params: { mid: this.$route.params.mid } })
              this.loginLoading = false
            }).catch(err => {
              window.console.log('err', err)
              this.loginLoading = false
            })
        } else {
          window.console.log('error login!!')
          return false
        }
      })
    },
    anonymousLogin () {
      const _this = this
      _this.loginLoading = true
      var params = new URLSearchParams()
      params.append('grant_type', 'password')
      params.append('login_mode', 'anonymous_voters')
      params.append('union_id', '003_aKLwerwer1')
      params.append('encrypt_unionid', '003_aKLwerwer1')
      // params.append('nickname', '002')
      params.append('meeting_id', _this.$route.params.mid)
      params.append('company_id', _this.$route.params.cid)
      _this.$api.account.login(params).then(data => {
        const saveParam = {
          token: data.access_token,
          token_type: data.token_type,
          refresh_token: data.refresh_token,
          expires_in: data.expires_in,
          issued: data['.issued'],
          expires: data['.expires'],
          role: 'voter',
          rememberClient: false
        }
        _this.$store.commit('ADD_ACCOUNT', saveParam)
        _this.$router.push({ name: 'voteList', params: { mid: _this.$route.params.mid } })
        _this.loginLoading = false
      }).catch(err => {
        window.console.log('err', err)
        _this.loginLoading = false
      })
    },
    openVoteUserApply: function () {
      const _this = this
      _this.$router.push({ name: 'voteUserApply', params: { mid: _this.$route.params.mid, cid: _this.$route.params.cid } })
    },
    watchLogin: function () {
      const _this = this
      _this.loginLoading = true
      var params = new URLSearchParams()
      params.append('grant_type', 'password')
      params.append('login_mode', 'watch_vote')
      params.append('union_id', '003_aKLwerwer')
      params.append('encrypt_unionid', '003_aKLwerwer')
      params.append('meeting_id', _this.$route.params.mid)
      params.append('company_id', _this.$route.params.cid)
      _this.$api.account.login(params).then(data => {
        const saveParam = {
          token: data.access_token,
          token_type: data.token_type,
          refresh_token: data.refresh_token,
          expires_in: data.expires_in,
          issued: data['.issued'],
          expires: data['.expires'],
          role: 'voter',
          rememberClient: false
        }
        _this.$store.commit('ADD_ACCOUNT', saveParam)
        _this.$router.push({ name: 'voteList', params: { mid: _this.$route.params.mid } })
        _this.loginLoading = false
      }).catch(err => {
        window.console.log('err', err)
        _this.loginLoading = false
      })
    }
  },
  mounted () {
    if (this.$route.params.mid === 'scan') {
      this.isShowLoginForm = false
    } else {
      this.isShowLoginForm = true
    }
    this.getVoteList()
  }
}
</script>

<style lang="less">
.vote_login_box {
  height: 100%;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  padding: 20px 10px 20px 10px;
  overflow-y: auto;
}
.vote_login_box .meeting_title {
  text-align: center;
  padding: 0px 0px 80px 0px;
  font-size: 24px;
  font-weight: 900;
}
.vote_login_scan {
  width: 100%;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: space-around;
  align-items: center;
}
.vote_login_scan a {
  background-color: #66b1ff;
  padding: 5px 8px;
  color: #fff;
  border-radius: 6px;
}
.vote_login_scan a .iconfont {
  font-size: 36px;
  margin-right: 0px;
}
.vote_login_row {
  width: 100%;
}
.login_submit_btn {
  width: 100%;
  font-size: 16px;
}
.login_divider {
  width: 100%;
  text-align: center;
  background: url('../../assets/images/login_divider.png') no-repeat;
  background-size: 100% 100%;
  //margin-top: 5px;
  margin-bottom: 20px;
}
.login_divider span {
  padding: 5px;
  background-color: #f4f6f8;
}
.user_apply_btn_box {
  width: 100%;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-around;
  align-items: center;
}
</style>
